import { render, staticRenderFns } from "./visually-hidden.vue?vue&type=template&id=4cd1acdb"
import script from "./visually-hidden.vue?vue&type=script&lang=js"
export * from "./visually-hidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports